import { FC } from 'react';
import { useSelector } from 'react-redux';

import { Flex } from '@bookjane2/bookjane-design-library';
import { WeeklyOverviewSection } from 'pages/WeeklyDashboardPage/WeeklyOverview';
import { H3 } from 'components/Typography';
import { SessionService } from 'services';
import { useTranslation } from 'hooks/useTranslation';
import { NeedsReviewSection } from 'pages/WeeklyDashboardPage/NeedsReview';
import { NeedsAttentionSection } from 'pages/WeeklyDashboardPage/NeedsAttention';
import { TeamMembersSection } from 'pages/WeeklyDashboardPage/TeamMembers';
import { withMemo } from 'utils/withMemo';
import { getCurrentlySelectedLocation } from 'utils/getCurrentlySelectedLocation';
import { DashboardPageContext } from 'pages/DashboardPage/DashboardPage.context';
import { QuerySwitch } from 'components/QuerySwitch';
import { isWeeklyDashboardFeatureEnabledSelector } from 'store/selectors/featureFlagSelectors';

export const WeeklyDashboardPageView: FC = () => {
  const sessionUser = SessionService.getUser();
  const { t } = useTranslation();
  const currentlySelectedLocation = getCurrentlySelectedLocation();
  const isWeeklyDashboardFeatureEnabled = useSelector(
    isWeeklyDashboardFeatureEnabledSelector(Number.parseInt(currentlySelectedLocation.id)),
  );
  return (
    <Flex padding="36px 44px 24px 63px" flexDirection="column">
      <Flex margin="0 0 24px">
        <H3>
          {t('new_dashboard:WELCOME_BACK')}, &nbsp;
          {sessionUser?.first_name}!
        </H3>
      </Flex>
      {isWeeklyDashboardFeatureEnabled && <WeeklyOverviewSection />}
      <Flex width="100%" gap="35px">
        <NeedsAttentionSection />
        <Flex width="50%" flexDirection="column" gap="38px">
          <NeedsReviewSection />
          <TeamMembersSection />
        </Flex>
      </Flex>
    </Flex>
  );
};

export const WeeklyDashboardPage: FC = withMemo(() => {
  return <QuerySwitch context={DashboardPageContext} component={WeeklyDashboardPageView} />;
});
